import * as SendBird from 'sendbird';

// tslint:disable-next-line:no-any
const SENDBIRD_APP_ID = (window as any).SENDBIRD_APP_ID || process.env.REACT_APP_SENDBIRD_APP_ID;

let instance: SendBirdAction | null = null;

export default class SendBirdAction {
  private _sb: SendBird.SendBirdInstance;

  constructor() {
    if (instance) {
      return instance;
    }
    this._sb = new SendBird({appId: SENDBIRD_APP_ID});
    instance = this;
  }

  public connect(userId: string) {
    return new Promise((resolve, reject) => {
      const sb = SendBird.getInstance();
      sb.connect(
        userId,
        (user, err) => {
          err ? reject(err) : resolve(user);
        }
      );
    });
  }

  public disconnect() {
    return new Promise<void>((resolve, reject) => {
      this._sb.disconnect((response, err) => {
        err ? reject(err) : resolve();
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/sb/SendBirdAction.ts